<template>
  <div id="lista-formulario-card">
    <div
      v-if="!aberto"
      class="lista-formulario-card-numero"
    >
      {{ entradaId }}
    </div>
    <div class="lista-formulario-card-form">
      <div :id="formContainerId"></div>
    </div>
    <div
      v-if="!aberto"
      class="lista-formulario-card-botao"
    >
      <el-link
        :underline="false"
        @click="expandir(!expandido)"
        style="color: #006FB9 !important;"
      >
        <i
          class="el-icon-arrow-up"
          v-if="expandido"
        ></i>
        <i
          class="el-icon-arrow-down"
          v-else
        ></i>
      </el-link>
    </div>
  </div>
</template>

<script>
import { renderForm } from '@mobilesaude/form-builder-sdk'
import { mapGetters } from 'vuex'

// const { renderForm } = FormBuilderSdk

export default {
  name: 'ListaFormularioCard',
  props: {
    entradaId: {
      type: [Number, String],
      default: 1
    },
    idForm: {
      type: [Number, String]
    },
    idData: {
      type: [Number, String]
    },
    clientKey: {
      type: String
    },
    aberto: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      meuForm: null,
      expandido: false,
      timestamp: 1
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    formBuilderColors () {
      const colors = this.estilo.formBuilder

      if (!colors) {
        return {}
      }

      return {
        primary: colors.corPrincipalFormBuilder,
        errors: colors.corErroFormBuilder,
        alert: colors.corAlertaFormBuilder
      }
    },
    formContainerId () {
      return `meuFormId_${this.idData}_${this.timestamp}`
    }
  },
  methods: {
    init () {
      this.meuForm = renderForm({
        identifier: this.formContainerId,
        clientKey: this.clientKey,
        idForm: this.idForm,
        readOnly: true,
        idData: this.idData,
        colors: { ...this.formBuilderColors }
      })

      this.meuForm.on('LOADING', res => {
        if (!this.aberto) {
          this.meuForm.showOnly(1)
        } else {
          this.meuForm.showAll()
        }
      })
    },
    expandir (abrir) {
      this.expandido = !!abrir
      if (this.expandido) {
        this.meuForm.showAll()
      } else {
        this.meuForm.showOnly(1)
      }
    }
  },
  mounted () {
    this.timestamp = Date.now()
    setTimeout(() => {
      this.init()
    }, 100)
  }
}
</script>
